import { instance } from 'api/axios';
import { Dispatch, AnyAction, Middleware } from 'redux';
import { RootState } from 'rootReducer';

const getData = (state: RootState) => ({
  branchId: state.commonReducer.logoutReducer.branchTitle?.id ?? '',
  roleValue: state.authModuleReducer.authReducer?.role?.name ?? '',
});

const updateAxiosHeaders = (getState: () => RootState) => {
  const { branchId, roleValue } = getData(getState());

  instance.defaults.headers.common['X-PreferredBranch'] = branchId;
  instance.defaults.headers.common['X-PreferredRole'] = roleValue;
};

const axiosMiddleware: Middleware =
  ({ getState }: { getState: () => RootState }) =>
  (next: Dispatch<AnyAction>) =>
  (action: AnyAction) => {
    updateAxiosHeaders(getState);

    return next(action);
  };

export default axiosMiddleware;
